module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": _vm.$t(((_vm.module.from.identifier) + ".label")) + ' > ' + _vm.$t(((_vm.module.to.identifier) + ".label"))
    }
  }, [_c('div', {
    staticClass: "l-row vertical-center"
  }, [_c('div', {
    staticClass: "l-col-4@md l-col-offset-1"
  }, [_c('img', {
    staticClass: "logo center",
    attrs: {
      "src": _vm.module.from.logo,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "l-col-2@md u-textCenter"
  }, [_c('i', {
    staticClass: "i-arrow icon-arrow-right center"
  })]), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md"
  }, [_c('img', {
    staticClass: "logo center",
    attrs: {
      "src": _vm.module.to.logo,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('footer', {
    staticClass: "c-card__footer u-textLeft"
  }, _vm._l((_vm.module.presets), function(preset) {
    return _c('button', {
      key: preset,
      staticClass: "btn btn--smart btn--sm btn--info",
      on: {
        "click": function($event) {
          return _vm.presetAction(preset)
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.$t(((preset.type) + ".label"))) + "\n    ")])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58052c8d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/presets/Card.vue
// module id = 3184
// module chunks = 0